import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import TextareaAutosize from "react-autosize-textarea/lib";
import { PulseLoader } from "react-spinners";

const FeedbackTextInput = ({
  text,
  placeholder = "",
  isDirty = false,
  labelledBy,
  onChange = () => { },
}) => {
  const { t } = useTranslation("components");

  return (
    <div className="feedback-text-input-container">
      <TextareaAutosize
        className="feedback-text-input"
        value={text}
        rows={1}
        placeholder={placeholder}
        aria-labelledby={labelledBy}
        onChange={(e) => { onChange(e.target.value) }} />
      {isDirty && (
        <div className="dirty-indicator" role="status">
          <PulseLoader size={6} color="#555" />
          <span className="visually-hidden">{t("status.saving")}</span>
        </div>
      )}
    </div>
  );
};

FeedbackTextInput.propTypes = {
  text: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  isDirty: PropTypes.bool,
  labelledBy: PropTypes.string,
};

export default FeedbackTextInput;
